module.exports = __webpack_public_path__ + "images/143_2048.jpg";